import { useMemo } from "react";
import { Grid, Button, Input } from "semantic-ui-react";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { ErrorText } from "components/form";
import { toast } from "components/Toast/Toast";
import _ from "lodash";

export const PrintSizeForm = ({
  printSizes,
  printSizeToUpdate,
  closePrintSizeForm,
  dispatch,
  t,
}) => {
  const NAME_MAX_NR_OF_CHARACTERS = 100;

  const printSizeSchema = yup.object().shape({
    name: yup
      .string()
      .required(t("required"))
      .max(
        NAME_MAX_NR_OF_CHARACTERS,
        t("name_max_character_count_error", { max_characters: NAME_MAX_NR_OF_CHARACTERS })
      ),
  });

  const initialValues = useMemo(
    () =>
      !printSizeToUpdate
        ? {
            name: "",
          }
        : {
            name: printSizeToUpdate.name,
          },
    [printSizeToUpdate]
  );

  const doesPrintSizeExist = (name) => {
    return !!_.find(printSizes, ["name", name]);
  };

  const submitCreate = async (values, actions) => {
    if (doesPrintSizeExist(values.name)) {
      actions.setFieldError("name", t("print_size_exists_error"));
      return;
    }

    try {
      await dispatch.printSizes.create(values);
      toast(undefined, t("print_size_create_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("print_size_create_failure"));
    }
    closePrintSizeForm();
  };

  const submitUpdate = async (values, actions) => {
    if (doesPrintSizeExist(values.name)) {
      actions.setFieldError("name", t("print_size_exists_error"));
      return;
    }

    try {
      await dispatch.printSizes.update({ id: printSizeToUpdate.id, ...values });
      toast(undefined, t("print_size_update_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("print_size_update_failure"));
    }
    closePrintSizeForm();
  };

  return (
    <Formik
      validationSchema={printSizeSchema}
      initialValues={initialValues}
      onSubmit={printSizeToUpdate ? submitUpdate : submitCreate}
    >
      {({ values, errors, isSubmitting, handleChange }) => (
        <Form>
          <h3>{printSizeToUpdate ? t("print_size_update") : t("print_size_create")}:</h3>
          <Grid columns={2} verticalAlign="middle">
            <Grid.Row className="form-field-row">
              <Grid.Column width={8}>
                <Input
                  placeholder={t("name_placeholder")}
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  fluid
                />
                <ErrorText name="name" />
              </Grid.Column>
              <Grid.Column width={2}>
                <Button primary type="submit" loading={isSubmitting}>
                  {printSizeToUpdate ? t("update") : t("create")}
                </Button>
                <Button
                  type="button"
                  basic
                  onClick={() => closePrintSizeForm()}
                  style={{ marginTop: "5px" }}
                >
                  {t("cancel")}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
